import { render } from "./NewFieldPage.vue?vue&type=template&id=e4b81c0a"
import script from "./NewFieldPage.vue?vue&type=script&lang=js"
export * from "./NewFieldPage.vue?vue&type=script&lang=js"

import "./NewFieldPage.vue?vue&type=style&index=0&id=e4b81c0a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__